import React from 'react'
import PropTypes from 'prop-types'

const ArticleIcon = (props) => {
  const { color = '#00B2AD', classes = 'w-20' } = props
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M5.08333 15.9167H12.6667V13.75H5.08333V15.9167ZM5.08333 11.5833H15.9167V9.41667H5.08333V11.5833ZM5.08333 7.25H15.9167V5.08333H5.08333V7.25ZM2.91667 20.25C2.32083 20.25 1.81076 20.0378 1.38646 19.6135C0.962153 19.1892 0.75 18.6792 0.75 18.0833V2.91667C0.75 2.32083 0.962153 1.81076 1.38646 1.38646C1.81076 0.962153 2.32083 0.75 2.91667 0.75H18.0833C18.6792 0.75 19.1892 0.962153 19.6135 1.38646C20.0378 1.81076 20.25 2.32083 20.25 2.91667V18.0833C20.25 18.6792 20.0378 19.1892 19.6135 19.6135C19.1892 20.0378 18.6792 20.25 18.0833 20.25H2.91667ZM2.91667 18.0833H18.0833V2.91667H2.91667V18.0833Z"
        fill={color}
      />
    </svg>
  )
}

ArticleIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(ArticleIcon)
